import React, {useMemo} from 'react';
import {
	LegacyFormSelectField,
	type LegacyFormSelectFieldProps,
} from '@netx/core-components/Form/SelectField';
import type {ICustomFormItem} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormBaseFieldName,
} from '../../utils';
import {getSelectOptionDisabled, getSelectOptionLabel} from './utils';

export interface LegacyFormCustomFormItemSelectProps
	extends Omit<
		LegacyFormSelectFieldProps<string, false, false, false>,
		'value' | 'label' | 'name' | 'required'
	> {
	item: ICustomFormItem;
	value?: string;
}

export const LegacyFormCustomFormItemSelectPrimitive = ({
	item,
	value: _value,
	...props
}: LegacyFormCustomFormItemSelectProps) => {
	const {label, value, required, userValue} = item;

	if (typeof value === 'string') return null;

	const options = useMemo(() => {
		return value.reduce<string[]>((accum, val) => {
			if (typeof val === 'string') return [...accum, val];
			if (val.disabled && val.key !== userValue) return accum;
			return [...accum, val.key];
		}, []);
	}, [value, userValue]);

	return (
		<LegacyFormSelectField<string, false, false, false>
			fullWidth
			{...props}
			disabled={props.disabled || item.disabled}
			label={getCustomFormItemTranslatedLabel(label)}
			name={getCustomFormBaseFieldName(item)}
			options={options}
			required={required}
			value={_value != null ? _value : null}
			getOptionDisabled={getSelectOptionDisabled(value)}
			getOptionLabel={getSelectOptionLabel(value)}
		/>
	);
};

export const LegacyFormCustomFormItemSelect =
	LegacyFormCustomFormItemSelectPrimitive;

export default LegacyFormCustomFormItemSelect;
